(() => {
  const selector = 'input.cl-po--input[type="radio"][name="properties[Paket Seçimi]"]';
  const preparePackaging = () => {
    const inputs = [...document.querySelectorAll(selector)];
    const groups = new Map();
    for (const input of inputs) {
      const key = input.getAttribute('form') || 'default';
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(input);
      const label = input.closest('label');
      const field = label?.parentElement;
      if (field && !field.classList.contains('nx-packaging')) field.classList.add('nx-packaging');
      if (input.value === 'Standart Kutu') {
        const text = label?.querySelector('span.visually-hidden');
        if (text && !text.dataset.nxLabel && text.textContent.trim() === input.value) {text.textContent = 'Standart Kutu · Ücretsiz';text.dataset.nxLabel = 'true';}
      }
    }
    for (const group of groups.values()) {
      if (group.some(input => input.checked)) continue;
      const standard = group.find(input => input.value === 'Standart Kutu' && !input.disabled);
      if (standard && !standard.dataset.nxDefault) {standard.dataset.nxDefault = 'true';standard.click();}
    }
  };
  let scheduled = false;
  const schedule = () => {if (scheduled) return;scheduled = true;requestAnimationFrame(() => {scheduled = false;preparePackaging();});};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once:true}); else schedule();
  const observer = new MutationObserver(records => {if (records.some(record => record.addedNodes.length)) schedule();});
  observer.observe(document.documentElement, {childList:true, subtree:true});
  document.addEventListener('shopify:section:load', schedule);
})();
